module.exports = __webpack_public_path__ + "img/saude.1b8b2020.png";